import { DialogHeading } from '@ariakit/react/dialog';
import { Trans, useTranslation } from 'react-i18next';
import type { LoginModalType } from 'types';

import InformationIcon from '~/assets/icons/Information';
import NewMailIcon from '~/assets/icons/NewMail';
import { Button, InternalLink } from '~/components/Button';

import ModalHeadings from '../ModalHeadings';
import type { ScreenProps } from '.';

type Props = ScreenProps & {
  email: string;
  modalType: LoginModalType;
};

const SignUpComplete = (props: Props) => {
  const { email, onDismiss, modalType } = props;

  const { t } = useTranslation();

  if (modalType === 'notifications')
    return <NotificationSignUpCompleteScreen {...props} />;

  return (
    <>
      <ModalHeadings>
        <Trans
          i18nKey="login.stageComplete.subHeading"
          values={{ email }}
          components={{ br: <br />, strong: <strong /> }}
        />
      </ModalHeadings>
      <div className="flex w-full flex-col items-start gap-4 bg-black">
        {modalType === 'profile' ? (
          <InternalLink
            variant="green-human"
            to="/"
            className="flex h-12 w-full items-center justify-center"
          >
            {t('done')}
          </InternalLink>
        ) : (
          <Button
            className="h-12 w-full"
            variant="green-human"
            onClick={() => onDismiss()}
          >
            {t('done')}
          </Button>
        )}
      </div>
    </>
  );
};

function NotificationSignUpCompleteScreen({ email }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex flex-col items-center gap-6 pb-6 pt-4 text-center">
        <DialogHeading className="flex flex-col content-center text-white">
          <h2 className="font-semibold text-white md:text-lg">
            {t('login.stepHeading', { step: 2 })}
          </h2>
        </DialogHeading>
        <div className="flex size-full flex-col items-center gap-2 text-center">
          <NewMailIcon height="41" width="41" stroke="#4B4B4B" />
          <p className="text-xs text-grey-hide">
            {t('login.stageComplete.confirmationMessage', { email })}
          </p>
          <p className=" text-white">
            {t('login.stageComplete.clickLinkMessage')}
          </p>
        </div>
        <div className="relative flex w-full items-center rounded-xl bg-yellow-label px-4 py-3 text-sm text-black">
          <p>
            <InformationIcon
              className="inline text-white"
              height={16}
              width={16}
            />
            <span className="ml-2">
              You won't receive notifications until you verify your email and
              create a password.
            </span>
          </p>
        </div>
      </div>
    </>
  );
}

export default SignUpComplete;
